<div class="topbar">
    <div *ngIf="signedIn" class="header-logo-mobile">
        <a [routerLink]="['/dashboard']">
            <img src="/assets/global/images/logo/logo-tevanpal.png" alt="Tevanpal">
        </a>
    </div>
    <div *ngIf="signedIn" class="header-left header-left-desktop">
        <ul class="main-nav">
            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <a [routerLink]="['/dashboard']"><i class="fa fa-folder-open"></i><span>Pratiche</span></a>
            </li>
            <li *ngIf="user.FKIDUserRole === 1" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <a [routerLink]="['/clienti']"><i class="fa fa-users"></i><span>Clienti</span></a>
            </li>
            <li *ngIf="user.FKIDUserRole === 1" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <a [routerLink]="['/fornitori']"><i class="fa fa-truck"></i><span>Fornitori</span></a>
            </li>
            <li *ngIf="user.FKIDUserRole === 1" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <a [routerLink]="['/segnalatori']"><i class="fa fa-user-plus"></i><span>Segnalatori</span></a>
            </li>
        </ul>
    </div>
    <div class="header-right">
        <ul *ngIf="signedIn" class="header-menu nav navbar-nav header-menu-desktop">
            <!-- BEGIN USER DROPDOWN -->
            <li class="dropdown" id="user-header">
                <a href="#" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
                    <span class="username">Bentornato, {{ user.Username }}!</span>
                </a>
                <ul class="dropdown-menu">
                    <!-- <li><a [routerLink]="['/personal/profile']"><i class="icon-user"></i><span>Profilo</span></a></li> -->
                    <!-- <li><a [routerLink]="['/personal/settings']"><i class="icon-settings"></i><span>Impostazioni</span></a></li> -->
                    <li><a style="cursor: pointer;" (click)="signOut($event)"><i class="icon-logout"></i><span>Logout</span></a></li>
                </ul>
            </li>
            <!-- END USER DROPDOWN -->
        </ul>
        <ul *ngIf="signedIn" class="header-menu nav navbar-nav header-menu-mobile">
            <li class="dropdown" [class.open]="mobileMenuOpen">
                <a href="#" class="mobile-menu-toggle" (click)="toggleMobileMenu($event)" aria-label="Menu">
                    <i class="fa fa-bars"></i>
                </a>
                <ul class="dropdown-menu dropdown-menu-right mobile-nav-menu">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                        <a [routerLink]="['/dashboard']" (click)="closeMobileMenu()">
                            <i class="fa fa-folder-open"></i><span>Pratiche</span>
                        </a>
                    </li>
                    <li *ngIf="user.FKIDUserRole === 1" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                        <a [routerLink]="['/clienti']" (click)="closeMobileMenu()">
                            <i class="fa fa-users"></i><span>Clienti</span>
                        </a>
                    </li>
                    <li *ngIf="user.FKIDUserRole === 1" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                        <a [routerLink]="['/fornitori']" (click)="closeMobileMenu()">
                            <i class="fa fa-truck"></i><span>Fornitori</span>
                        </a>
                    </li>
                    <li *ngIf="user.FKIDUserRole === 1" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                        <a [routerLink]="['/segnalatori']" (click)="closeMobileMenu()">
                            <i class="fa fa-user-plus"></i><span>Segnalatori</span>
                        </a>
                    </li>
                    <li>
                        <a style="cursor: pointer;" (click)="signOut($event)">
                            <i class="icon-logout"></i><span>Logout</span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    <!-- header-right -->
</div>
